import s from './Card.module.scss'
interface Props {
  children: React.ReactNode[] | React.ReactNode
  variant: 'primary' | 'secondary'
  style?: React.CSSProperties
  onClick?: (e: React.MouseEvent) => void
  selected?: boolean
  className?: string
  testid?: string
}

export const Card = ({ children, variant, selected, style, onClick, className, testid }: Props) => {
  return (
    <div
      className={`${s.card} ${s[variant]} ${selected && s.selected} ${className || ''}`}
      style={style}
      onClick={onClick}
      data-testid={testid}
    >
      {children}
    </div>
  )
}

interface ImageProps {
  children: React.ReactNode[] | React.ReactNode
  height: number | string
}
const Image = ({ children, height }: ImageProps) => (
  <div className={s.cardImage} style={{ height }}>
    {children}
  </div>
)
Card.Image = Image

interface InfoProps {
  children: React.ReactNode[] | React.ReactNode
  style?: React.CSSProperties
  className?: string
}
const Info = ({ children, style, className }: InfoProps) => (
  <div className={`${s.cardInfo} ${className}`} style={style}>
    {children}
  </div>
)
Card.Info = Info

interface CroppedTextProps {
  children: React.ReactNode[] | React.ReactNode
  style?: React.CSSProperties
  className?: string
}
const CroppedText = ({ children, style, className }: CroppedTextProps) => (
  <div className={`${s.cardCroppedText} ${className}`} style={style}>
    {children}
  </div>
)
Card.CroppedText = CroppedText
